module.exports = __webpack_public_path__ + "static/media/padlock-wizard.9c78704f.svg";